module.exports = __webpack_public_path__ + "img/sword-icon.d3d2a123.svg";